import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'app/common/base/base.component';
import { Dialog } from 'app/common/dialog';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-api-image',
    templateUrl: './api-image.component.html',
    styleUrls: ['./api-image.component.scss'],
    standalone: false
})
export class ApiImageComponent extends BaseComponent implements OnChanges {
  @Input() src: string;
  @Input() sourceSize: string | null = null;
  @Input() override: string | null = null;
  @Input() height: any = null;
  @Input() width: any = null;
  @Input() imgClass: string = "";
  @Input() defaultSource: string | null = null;

  loading = true;

  constructor(
    public _translateService: TranslateService,
    protected dialog: Dialog,
    public title: Title,
    public logger: NGXLogger,
    public changes: ChangeDetectorRef
  ) {
    super(_translateService, title, dialog, logger);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.src?.currentValue) {
      this.loading = true;
    }
  }

  onLoad(): void{
    this.loading = false;
  }

}
